import httpClient from "../utils/httpClient";

export const getReportListApi = async (payload) => {
    const response = await httpClient.post("/Reports/GetReportList", payload);
    return response.data;
};